import { render, staticRenderFns } from "./event_item.vue?vue&type=template&id=d54e09fe&scoped=true"
import script from "./event_item.vue?vue&type=script&lang=js"
export * from "./event_item.vue?vue&type=script&lang=js"
import style0 from "./event_item.vue?vue&type=style&index=0&id=d54e09fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d54e09fe",
  null
  
)

export default component.exports